import { Injectable } from '@angular/core';
import {Http} from '@angular/http';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class StakeholdersTecnicosService extends Service{

  protected url: string = this.dominio+"/adm/laudos-tecnicos/stakeholders/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

}




// WEBPACK FOOTER //
// ./src/app/laudos-tecnicos-stakeholders/stakeholders.service.ts